import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import { Link, useHistory } from 'react-router-dom';
import SearchBar from '../../Components/Utility/FilterAction/SearchBar';
import UserGroupsCard from '../../Components/Card/UserGroupsCard/UserGroupsCard';
import BtnSelectAll from '../../Components/Utility/FilterAction/BtnSelectAll';
import { MoreIcon, AddIcon, DeleteIcon } from '../../bombiix-icon';
import AddEditUserGroup from './AddEditUserGroup';
import Loader from '../../Components/Utility/Loader/Loader';
import * as action from './store/User.action';
import BtnSort from '../../Components/Utility/FilterAction/BtnSort';
import { Page_Size } from '../../Components/helper';
import './UserRights.css';

function UserGroups() {
  const [state, setState] = useState({
    colourLibraryGroups: [],
    loading: false,
    searchText: '',
    searchLoaded: false,
    sortBy: null,
    pageIndex: 1,
    pageSize: Page_Size,
    hasMore: false,
    totalRecords: 0,
  });
  const dispatch = useDispatch();
  const [selectedEditId, setSelectedEditId] = useState('');
  const [addEditModal, setAddEditModal] = useState(false);
  const { t } = useTranslation('common');
  const history = useHistory();
  const UsersReducers = useSelector((reducerstate) => reducerstate);
  const { Users } = UsersReducers;
  const { userGroupsCardList } = Users;
  const [groupsList, SetGroupList] = useState([]);
  const [selectedIdArray, setSelectedIdArray] = useState([]);
  const [showSearchMobile, setSearchMobile] = useState(false);
  const [isSelectAll, setSelectAll] = useState(false);

  const sortByOptions = [
    {
      value: 'Asc',
      propertyName: 'name',
      label: t('USER_GROUPS.GROUP_NAME_ASCENDING'),
    },
    {
      value: 'Desc',
      propertyName: 'name',
      label: t('USER_GROUPS.GROUP_NAME_DESCENDING'),
    },
  ];

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (state.searchLoaded) {
        setState((search2state) => ({
          ...search2state,
          loading: true,
          pageIndex: 1,
          bomLibraryList: [],
          totalRecords: null,
          hasMore: true,
        }));
        setSelectedIdArray([]);
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [state.searchText]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (userGroupsCardList) {
      const list = [...userGroupsCardList];
      setState((fetchstate) => ({
        ...fetchstate,
        loading: true,
      }));
      SetGroupList(list);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userGroupsCardList]);

  const onSelectCheckBox = async (_e, id) => {
    let selectedItems = [...selectedIdArray];
    const findItems = selectedItems.filter((item) => item === id);
    if (!isEmpty(findItems)) {
      selectedItems = selectedItems.filter((item) => item !== id);
      setSelectedIdArray([...selectedItems]);
    } else {
      setSelectedIdArray([...selectedItems, id]);
    }
  };

  const onEdit = (id) => {
    setSelectedEditId(id);
    setAddEditModal(true);
  };

  const toggleAddNewUserGroupModal = () => {
    setSelectedEditId(null);
    setAddEditModal(!addEditModal);
  };
  const toggleAddEditModal = () => {
    setSelectedEditId(null);
    setAddEditModal(!addEditModal);
  };

  const titles = () => {
    return !isEmpty(selectedEditId) ? t('USER_GROUPS.UPDATE_USER_GROUP') : t('USER_GROUPS.ADD_USER_GROUP');
  };

  const fetchApi = async () => {
    await dispatch(action.fetchUserGroupsCards());
  };
  useEffect(() => {
    fetchApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDeleteCard = async (id) => {
    await dispatch(action.deleteUserGroupsCards([id], t));
    fetchApi();
  };

  const multiDelete = async () => {
    await dispatch(action.deleteUserGroupsCards(selectedIdArray, t));
    fetchApi();
    setSelectedIdArray([]);
  };

  const handleSortBy = async (val) => {
    const params = {
      sortByPropertyName: 'name',
      sortOrder: val?.value,
    };

    setState((prev) => ({
      ...prev,
      sortBy: val,
    }));
    await dispatch(action.fetchUserGroupsCards(params));
  };

  const handleSearch = async (e) => {
    const targetValue = e.target.value;
    setState((search1state) => ({
      ...search1state,
      searchText: targetValue,
      searchLoaded: true,
    }));
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (state.searchLoaded) {
        const params = {
          searchText: state.searchText,
          isSelectAll: false,
          selectedIdArray: [],
        };
        dispatch(action.fetchUserGroupsCards(params));
        setState((getstate) => ({
          ...getstate,
          loading: false,
          searchLoaded: false,
        }));
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [state.searchText]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleMobileSearch = (clear) => {
    if (clear) {
      setState((mobstate) => ({
        ...mobstate,
        searchText: '',
        searchLoaded: true,
      }));
    }
    setSearchMobile(!showSearchMobile);
  };

  const handleSelectAll = () => {
    if (isSelectAll) {
      setSelectedIdArray([]);
    } else {
      const selectedItems = [...selectedIdArray];
      for (const item of groupsList) {
        const findItems = selectedItems.filter((val) => val === item._id);
        if (findItems.length === 0) {
          selectedItems.push(item._id);
        }
      }
      setSelectedIdArray(selectedItems);
    }
    setSelectAll(!isSelectAll);
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container ">
          <h4 className="title">{t('USER_GROUPS.HEADER_TEXT')}</h4>
        </div>
        <div className="search-filter" style={{ paddingLeft: '40%' }}>
          <SearchBar
            placeholder={t('USER_GROUPS.SEARCH_USER_GROUP')}
            onSearch={handleSearch}
            value={state.searchText}
            showMobileSearch={showSearchMobile}
            handleMobileSearch={handleMobileSearch}
          />
          <button type="button" className="filter-btn btn-mobile-more">
            <MoreIcon size={28} />
          </button>
          <button type="button" className="filter-btn filter-button_add" onClick={() => toggleAddNewUserGroupModal()}>
            <AddIcon size={24} />
          </button>
          <button type="button" className="filter-btn filter-button_add" disabled={!selectedIdArray.length} onClick={() => multiDelete()}>
            <DeleteIcon size={24} />
          </button>
          <BtnSort options={sortByOptions} onBtnClick={handleSortBy} val={state.sortBy} />
          <BtnSelectAll handleSelectAll={handleSelectAll} isSelectAll={isSelectAll} isDisabled={isEmpty(groupsList)} />
          <button
            type="button"
            className="btn btn-white btn-back-lib"
            onClick={() => {
              history.push('/settings/user-library');
            }}
          >
            {t('USER_GROUPS.BACK')}
          </button>
        </div>
      </div>
      <div className="container-fluid">
        <div className="d-flex justify-content-end my-3">
          <Link
            className={`cursor-pointer text-dark text-decoration-none ${
              window.location.href.includes('/user-library') ? 'btn-active btn btn-page-filter' : 'btn btn-page-filter'
            }`}
            to="/settings/user-library"
          >
            <span className="lib-name">{t('USER_GROUPS.USER_LIBRARY')}</span>
          </Link>
          <Link
            className={`cursor-pointer text-dark text-decoration-none ${
              window.location.href.includes('/user-groups') ? 'btn-active btn btn-page-filter' : 'btn btn-page-filter'
            }`}
            to="/settings/user-groups"
          >
            <span className="lib-name">{t('USER_GROUPS.USER_GROUP')}</span>
          </Link>
        </div>

        {state.loading === true && groupsList && isEmpty(groupsList) && (
          <div>
            <div className="w-100 text-center">
              <Container fluid className="py-4">
                <Row>
                  <Col md="12">
                    <p className="alert alert-info override-alert-info">{t('USER_GROUPS.NO_USER_GROUP_FOUND')}</p>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        )}
      </div>
      {state.loading === false ? (
        <Loader />
      ) : (
        state.loading === true &&
        groupsList &&
        !isEmpty(groupsList) && (
          <div className="container-fluid">
            <div className="row">
              {groupsList.map((item, i) => {
                return (
                  !isEmpty(item.name) &&
                  item?.name !== 'Not Applicable' && (
                    <React.Fragment key={item?._id}>
                      <UserGroupsCard
                        item={item}
                        index={i}
                        onCheck={onSelectCheckBox}
                        selectedIds={selectedIdArray}
                        editeble
                        onEdit={onEdit}
                        isImport={false}
                        onDelete={handleDeleteCard}
                      />
                    </React.Fragment>
                  )
                );
              })}
            </div>
          </div>
        )
      )}
      {addEditModal && <AddEditUserGroup onOpen={addEditModal} title={titles()} id={selectedEditId} toggle={toggleAddEditModal} itemList={groupsList} />}
    </>
  );
}

export default UserGroups;
